export const DEFAULT_SIZE = { sizeX: 2, sizeY: 2 };

// If a widget type is not in the registry, this is the fallback allowed set.
export const FALLBACK_ALLOWED_SIZES = [
  { sizeX: 1, sizeY: 1 },
  { sizeX: 2, sizeY: 2 },
  { sizeX: 4, sizeY: 4 },
];

export const sizesEqual = (a, b) => a.sizeX === b.sizeX && a.sizeY === b.sizeY;

export const clampToAllowed = (allowed, sizeX, sizeY) => {
  if (!allowed || allowed.length === 0) return { sizeX, sizeY };
  // Snap to the closest allowed tuple by manhattan distance.
  return allowed.reduce((best, candidate) => {
    const bestScore = Math.abs(best.sizeX - sizeX) + Math.abs(best.sizeY - sizeY);
    const score = Math.abs(candidate.sizeX - sizeX) + Math.abs(candidate.sizeY - sizeY);
    return score < bestScore ? candidate : best;
  });
};
